module.exports = __webpack_public_path__ + "img/img6.c7965c52.svg";